export default function getDisplayName(ComposedComponent, hoc) {
  const name = `${ComposedComponent.displayName ||
    ComposedComponent.name ||
    `Component`}`

  return `with${hoc}(${name})`
}
